import { Checkbox, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  label: string;
  onClick: () => void;
};

export function SelectedClientPill({ label, onClick }: Props) {
  return (
    <Flex
      align="center"
      gap="xs"
      px="md"
      py="xs"
      bg="gray.0"
      style={{
        borderRadius: 20,
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Checkbox checked onChange={onClick} onClick={e => e.stopPropagation()} radius="sm" />
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {label}
      </Text>
    </Flex>
  );
}
